module.exports = __webpack_public_path__ + "static/media/full-screen.2361ae7c.svg";